import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api_url } from "../globalFunction/global_string";
import '../TrackingHook/TrackingHookCss.css';
import Swal from 'sweetalert2';
import { SelectNet } from "../BasicComponents/SelectNet";
import { SelectUnitproxyApply } from "../BasicComponents/SelectUnitproxyApply";
import SelectReport from "../BasicComponents/SelectReport";
import SelectUrlTKBG from "../BasicComponents/SelectUrlTKBG";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, Card, Col, CardBody, CardHeader } from 'reactstrap';
import { FaTrash, FaTrashAlt } from 'react-icons/fa';
import withReactContent from 'sweetalert2-react-content';
import SelectTenableUrl from "../BasicComponents/SelectTenableUrl";
import SelectTenableReport from "../BasicComponents/SelectTenableReport";

import SelectTenableNet from "../BasicComponents/SelectTenableNet";
import SelectTenableUnit from "../BasicComponents/SelectTenableUnit";


const riskLevelMapping = {
    '重': 5,
    '高': 4,
    '中': 3,
    '低': 2,
    '資訊': 1
};


function ViewTenableTrackingList() {
    const navigate = useNavigate();
    const MySwal = withReactContent(Swal);
    const [modal, setModal] = useState(false); // 定義模態對話框狀態
    const [groupedData, setGroupedData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedReports, setExpandedReports] = useState({});
    const [formValues, setFormValues] = useState({
        build_date: '',
        projectName: '',
        projectStartTime: '',
        projectEndTime: '',
        riskLevels: [5, 4, 3], // 預設選中"高"和"中"
        selectedDuration: '1',
        isSubmitted: false,
        projectStore: false
    });

    //風險值
    const [statistics, setStatistics] = useState({
        totalUnrespondedUnitCount: '',
        totalNotPassedUnitCount: '',
        totalPassedUnitCount: '',
        grandTotalUnitCount: '',
        totalUnrespondedUnitCountForNonSubmission: '',
        totalNotPassedUnitCountForReviewedAndNeedsRevision: ''
    });
    const [selectnet, setSelectnet] = useState("");
    const [local_net_name, setLocal_net_name] = useState("");
    const [selectUnit, setSelectUnit] = useState("");
    const [local_unit_name, setLocal_unit_name] = useState("");
    const [selecturl, setSelectUrl] = useState("");
    const [local_Url_name, setLocal_Url_name] = useState("");
    const [selectreport, setSelectreport] = useState("");
    const [local_report_name, setLocal_report_name] = useState("");
    const [trackingReports, setTrackingReports] = useState([
        { id: '', selectNet: '', selectUnit: '', selectUrl: '', selectReport: '', local_net_name: '', local_unit_name: '', local_Url_name: '', local_report_name: '', selectedDuration: '1' }
    ]);
    const [buttonStates, setButtonStates] = useState({});
    // 分頁狀態
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    // 根據選擇的每頁項目數動態計算總頁數
    const totalPages = Math.ceil(Object.entries(groupedData).length / itemsPerPage);

    // 計算當前頁的數據
    const totalItems = Object.keys(groupedData).length;

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = currentPage * itemsPerPage;

    // 轉換 groupedData 為數組並過濾出當前頁面的數據條目
    const currentItems = Object.entries(groupedData).slice(indexOfFirstItem, indexOfLastItem);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1); // 重設回第一頁
    };


    // 處理表單輸入變更
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        if (name === 'projectEndTime' && new Date(value) < new Date(formValues.projectStartTime)) {
            Swal.fire({
                title: '錯誤!',
                text: '追蹤計畫結束時間不能小於開始時間',
                icon: 'error',
                confirmButtonText: '好的'
            });
            return;
        }

        setFormValues(prevValues => ({
            ...prevValues,
            [name]: value
        }));
    };

    // 處理風險等級變更
    const handleRiskLevelChange = (event) => {
        const { value } = event.target;
        const numValue = riskLevelMapping[value];
        setFormValues(prevValues => ({
            ...prevValues,
            riskLevels: prevValues.riskLevels.includes(numValue)
                ? prevValues.riskLevels.filter(level => level !== numValue)
                : [...prevValues.riskLevels, numValue].sort((a, b) => a - b)
        }));
    };

    // 處理網路選擇變更
    const handleNetSelectChange = (data, index) => {
        const { value, selectedName } = data;
        console.log('Net Selected:', { value, selectedName, index });

        const updatedReports = [...trackingReports];
        updatedReports[index].selectNet = value;
        updatedReports[index].local_net_name = selectedName;
        updatedReports[index].selectUnit = ''; // 重置單位選擇
        updatedReports[index].local_unit_name = '';
        setTrackingReports(updatedReports);
    };

    // 處理單位選擇變更
    const handleUnitSelectChange = (data, index) => {
        const { value, selectedName } = data;
        console.log('Unit Selected:', { value, selectedName, index });

        const updatedReports = [...trackingReports];
        updatedReports[index].selectUnit = value;  // 更新選中的單位
        updatedReports[index].local_unit_name = selectedName;  // 更新顯示名稱
        setTrackingReports(updatedReports);
    };


    // 處理 URL 選擇變更
    const handleUrlSelectChange = (data, index) => {
        const { value, selectedName } = data;
        console.log('URL Selected:', { value, selectedName, index });

        const updatedReports = [...trackingReports];
        updatedReports[index].selectUrl = value; // 更新選擇的 URL 或 Host
        updatedReports[index].local_Url_name = selectedName; // 更新選擇的名稱 (IP 地址)
        updatedReports[index].selectedHostIp = selectedName; // 更新選擇的主機 IP
        setTrackingReports(updatedReports);
    };

    // 處理報告選擇
    const selectReport = (data, index) => {
        setSelectreport(data.value);

        const updatedReports = [...trackingReports];
        updatedReports[index].selectReport = data.value;
        updatedReports[index].local_report_name = data.selectedName;

        setTrackingReports(updatedReports);
        console.log('更新後的追蹤報告清單:', updatedReports);
    };




    //報告時間
    const durationOptions = [
        { label: '1個月', value: '1' },
        { label: '3個月', value: '3' },
        { label: '6個月', value: '6' },
        { label: '一年', value: '12' },
        { label: '二年', value: '24' },
        { label: '三年', value: '36' },
    ];


    // 新增追蹤報告
    const addTrackingReport = () => {
        setTrackingReports([
            ...trackingReports,
            { id: '', selectNet: '', selectUnit: '', selectUrl: '', selectReport: '', local_net_name: '', local_unit_name: '', local_Url_name: '', local_report_name: '', selectedDuration: '1' }
        ]);
    };

    // 更新指定追蹤報告的資料
    const updateTrackingReport = (index, field, value) => {
        const updatedReports = trackingReports.map((report, i) => {
            if (i === index) {
                return { ...report, [field]: value };
            }
            return report;
        });
        setTrackingReports(updatedReports);
    };
    const removeTrackingReport = (index) => {
        setTrackingReports(prevReports => prevReports.filter((_, i) => i !== index));
    };


    //直接刪除報告
    const deleteReport = async (reportId) => {
        const result = await Swal.fire({
            title: '您確定嗎?',
            text: "直接刪除報告將無法恢復！",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '是的，刪除它！',
            cancelButtonText: '取消'
        });
        if (result.isConfirmed) {
            let apiUrl = api_url + '/api/TrackBackground/DelTenTrackBackgroundlist';
            const formData = new FormData();
            formData.append("id", reportId);
            fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            })
                .then(response => response.json())
                .then(response => {
                    if (response.result.statusCode === 200) {
                        loadData();
                        setExpandedReports({});
                    } else {
                        throw new Error('Invalid response format');
                    }
                })
        }
    };


    const groupByAttributes = (reports) => {
        const grouped = {};
        reports.forEach((report) => {
            const groupKey = `${report.build_date}-${report.projectName}-${report.projectStartTime}-${report.projectEndTime}`;
            if (!grouped[groupKey]) {
                grouped[groupKey] = [];
            }
            grouped[groupKey].push(report);
        });

        // 對組合鍵進行排序
        const sortedGroupKeys = Object.keys(grouped).sort((a, b) => {
            // 正確提取日期部分並轉換為日期對象進行比較
            const dateA = new Date(a.split('-')[0]); // 假設日期時間是第一個元素
            const dateB = new Date(b.split('-')[0]);
            return dateB - dateA;
        });

        // 使用排序後的鍵來創建一個新的物件
        const sortedGrouped = {};
        sortedGroupKeys.forEach(key => {
            sortedGrouped[key] = grouped[key];
        });

        return sortedGrouped;
    };

    //一開始進來讀取api的資料
    const loadData = () => {
        let apiUrl = api_url + '/api/TrackBackground/GetTenTrackBackgroundlist';
        const formData = new FormData();
        formData.append('user_type', localStorage.getItem('login_user_type'));
        formData.append('local_net_id', localStorage.getItem('login_user_net_id'));
        formData.append('local_unit_id', localStorage.getItem('login_user_unit_id'));
        fetch(apiUrl, {
            method: "POST",
            headers: { "Authorization": localStorage.getItem('accessToken') },
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if (data.statusCode === 200) {
                    setGroupedData(groupByAttributes(data.row));
                } else {
                    throw new Error('Invalid response format');
                }
                setIsLoading(false);
            })
            .catch(error => {
                setError(error);
                setIsLoading(false);
            });
    };

    useEffect(() => {
        loadData();
        const timers = {};

        Object.entries(buttonStates).forEach(([key, value]) => {
            if (value.isDisabled) {
                timers[key] = setInterval(() => {
                    setButtonStates(prevStates => {
                        const currentTimer = prevStates[key].timer;
                        if (currentTimer === 1) {
                            clearInterval(timers[key]);
                            return { ...prevStates, [key]: { isDisabled: false, timer: 60 } };
                        }
                        return { ...prevStates, [key]: { ...prevStates[key], timer: currentTimer - 1 } };
                    });
                }, 1000);
            }
        });

        // 清理函数
        return () => {
            Object.values(timers).forEach(clearInterval);
        };
    }, [buttonStates]);


    //詳細資訊
    const handleItemClick = (buildDate, projectName, projectStartTime, projectEndTime) => {
        navigate('/ViewhostTrackingDetail', { state: { buildDate, projectName, projectStartTime, projectEndTime } });
    };
    //追蹤按鈕收合功能
    const toggleExpand = (reportKey) => {
        const reportData = groupedData[reportKey];
        const isCurrentlyExpanded = expandedReports[reportKey];

        if (reportData && !isCurrentlyExpanded) {
            console.log('Selected Unit:', reportData[0].projectunit);  // 檢查單位是否正確
            setFormValues({
                projectName: reportData[0].projectName || '',
                projectStartTime: reportData[0].projectStartTime || '',
                projectEndTime: reportData[0].projectEndTime || '',
                riskLevels: getRiskLevelsFromData(reportData[0]),
                projectStore: reportData[0].projectStore,
                projectTemporarilySave: reportData[0].projectTemporarilySave,
                build_date: reportData[0].build_date,
            });

            // 设置 trackingReports
            const updatedReports = reportData.map(report => {
                console.log(reportData)
                return {
                    id: report.id,
                    selectNet: report.projectnet || '',
                    selectUnit: report.projectunit || '',
                    selectUrl: report.projecturl || '',
                    selectReport: report.projectreport || '',
                    local_net_name: report.local_net_name || '',
                    local_unit_name: report.local_unit_name || '',
                    local_Url_name: report.host_ip || '',
                    local_report_name: report.projectreportname || '',
                    selectedDuration: report.projectllimit || '1',
                    selectedHostIp: report.host_ip || ''
                };
            });



            setTrackingReports(updatedReports);
        }

        const updatedExpandedReports = { ...expandedReports };
        updatedExpandedReports[reportKey] = !isCurrentlyExpanded;
        setExpandedReports(updatedExpandedReports);
    };




    //儲存報告
    const handleSave = async () => {
        // 驗證邏輯
        if (formValues.projectName.trim() === '') {
            Swal.fire('錯誤', '請填寫專案名稱', 'error');
            return;
        }

        if (formValues.projectStartTime === '' || formValues.projectEndTime === '') {
            Swal.fire('錯誤', '請填寫追蹤計畫開始時間和結束時間', 'error');
            return;
        }

        if (new Date(formValues.projectEndTime) < new Date(formValues.projectStartTime)) {
            Swal.fire('錯誤', '結束追蹤時間不能早於追蹤時間', 'error');
            return;
        }

        if (formValues.riskLevels.length === 0) {
            Swal.fire('錯誤', '請至少選擇一個風險等級', 'error');
            return;
        }

        if (trackingReports.length === 0 || trackingReports.some(report => report.selectReport.trim() === '')) {
            Swal.fire('錯誤', '請至少新增一個追蹤報告', 'error');
            return;
        }

        // 新增檢查 selectReport 是否重複的邏輯
        const selectReportSet = new Set();

        for (const report of trackingReports) {
            if (selectReportSet.has(report.selectReport)) {
                Swal.fire('錯誤', '追蹤報告中有重複的報告選擇', 'error');
                return;
            }
            if (!report.selectUnit || !report.selectUrl) {
                Swal.fire('錯誤', '您有一個或多個下拉選單未選擇', 'error');
                return;
            }
            selectReportSet.add(report.selectReport);
        }

        let apiUrl = api_url + '/api/TrackBackground/PUTTenTrackBackgroundlist';

        let allReportsSubmittedSuccessfully = true;
        for (const report of trackingReports) {
            const formData = new FormData();
            formData.append('user_type', localStorage.getItem('login_user_type'));
            formData.set('id', report.id)
            formData.set('projectHeavyRisk', formValues.riskLevels.includes(5) ? 'true' : 'false');
            formData.set('projectHighRisk', formValues.riskLevels.includes(4) ? 'true' : 'false');
            formData.set('projectMediumRisk', formValues.riskLevels.includes(3) ? 'true' : 'false');
            formData.set('projectLowRisk', formValues.riskLevels.includes(2) ? 'true' : 'false');
            formData.set('projectInformationRisk', formValues.riskLevels.includes(1) ? 'true' : 'false');
            formData.set('projectName', formValues.projectName);
            formData.set('projectStartTime', formValues.projectStartTime);
            formData.set('projectEndTime', formValues.projectEndTime);
            formData.set('selectedDuration', formValues.selectedDuration);
            formData.set('local_net_id', localStorage.getItem('login_user_net_id'));
            formData.set('local_unit_id', localStorage.getItem('login_user_unit_id'));
            if (userType === 'S') {
                formData.set('projectnet', report.selectNet);
                formData.set('projectunit', report.selectUnit);
            } else if (userType === 'M') {
                formData.set('projectnet', localStorage.getItem('login_user_net_id'));
                formData.set('projectunit', report.selectUnit);
            } else if (userType === 'N') {
                formData.set('projectnet', localStorage.getItem('login_user_net_id'));
                formData.set('projectunit', localStorage.getItem('login_user_unit_id'));
            }
            formData.set('projecturl', report.selectUrl);
            formData.set('projecturlname', report.local_Url_name);
            formData.set('projectllimit', report.selectedDuration);
            formData.set('projectreport', report.selectReport);
            formData.set('projectreportname', report.local_report_name);
            formData.set('projectTemporarilySave', true)
            if (userType === 'S') {
                formData.set('IsadminbuildTrack', 'true');
            } else if (userType === 'M') {
                formData.set('IsNetbuildTrack', 'true');
            } else if (userType === 'N') {
                formData.set('IsUnitbuildTrack', 'true');
            }
            if (userType === 'S') {
                formData.set('IsadminTrack', 'true');
                formData.set('IsNetTrack', 'false');
                formData.set('IsUnitTrack', 'false');
            } else if (userType === 'M') {
                formData.set('IsNetTrack', 'true');
                formData.set('IsadminTrack', 'false');
                formData.set('IsUnitTrack', 'false');
            } else if (userType === 'N') {
                formData.set('IsUnitTrack', 'true');
                formData.set('IsNetTrack', 'false');
                formData.set('IsadminTrack', 'false');
            } else {
                formData.set('IsadminTrack', 'false');
                formData.set('IsNetTrack', 'false');
                formData.set('IsUnitTrack', 'false');
            }
            formData.set('build_date', formValues.build_date);
            for (const key in report) {
                formData.append(key, report[key]);
            }
            MySwal.fire({
                title: '處理中...',
                text: '報告修改中',
                allowOutsideClick: false,
                showConfirmButton: false,
                onBeforeOpen: () => {
                    MySwal.showLoading();
                }
            });
            try {
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: { "Authorization": localStorage.getItem('accessToken') },
                    body: formData
                });
                const data = await response.json();
            } catch (error) {
                allReportsSubmittedSuccessfully = false;
                console.error('提交錯誤:', error);
            }
        }

        MySwal.close();

        if (allReportsSubmittedSuccessfully) {
            Swal.fire({
                title: '成功!',
                text: '所有追蹤報告儲存成功，您可以去追蹤清單查看',
                icon: 'success',
                confirmButtonText: '好的'
            }).then((result) => {
                if (result.isConfirmed) {
                    loadData();
                    setExpandedReports({});
                }
            });

            setFormValues({
                projectName: '',
                projectStartTime: '',
                projectEndTime: '',
                riskLevels: [5, 4, 3],
                selectedDuration: '1',
                isSubmitted: false,
            });
            setTrackingReports([
                { selectNet: '', selectUnit: '', selectUrl: '', selectReport: '', local_net_name: '', local_unit_name: '', local_Url_name: '', local_report_name: '', selectedDuration: '1' }
            ]);
        }
    };

    //提交報告
    const handleSubmit = async (event) => {
        event.preventDefault();
        // 驗證邏輯
        if (formValues.projectName.trim() === '') {
            Swal.fire('錯誤', '請填寫專案名稱', 'error');
            return;
        }

        if (formValues.projectStartTime === '' || formValues.projectEndTime === '') {
            Swal.fire('錯誤', '請填寫追蹤計畫開始時間和結束時間', 'error');
            return;
        }

        if (new Date(formValues.projectEndTime) < new Date(formValues.projectStartTime)) {
            Swal.fire('錯誤', '結束追蹤時間不能早於追蹤時間', 'error');
            return;
        }

        if (formValues.riskLevels.length === 0) {
            Swal.fire('錯誤', '請至少選擇一個風險等級', 'error');
            return;
        }

        if (trackingReports.length === 0 || trackingReports.some(report => report.selectReport.trim() === '')) {
            Swal.fire('錯誤', '請至少新增一個追蹤報告', 'error');
            return;
        }


        // 新增檢查 selectReport 是否重複的邏輯
        const selectReportSet = new Set();

        for (const report of trackingReports) {
            if (selectReportSet.has(report.selectReport)) {
                Swal.fire('錯誤', '追蹤報告中有重複的報告選擇', 'error');
                return;
            }
            if (!report.selectUnit || !report.selectUrl) {
                Swal.fire('錯誤', '您有一個或多個下拉選單未選擇', 'error');
                return;
            }
            selectReportSet.add(report.selectReport);
        }

        let apiUrl = api_url + '/api/TrackBackground/PUTTenTrackBackgroundlist';
        const formData = new FormData();

        let allReportsSubmittedSuccessfully = true;
        for (const report of trackingReports) {
            formData.set('id', report.id)
            formData.set('projectHeavyRisk', formValues.riskLevels.includes(5) ? 'true' : 'false');
            formData.set('projectHighRisk', formValues.riskLevels.includes(4) ? 'true' : 'false');
            formData.set('projectMediumRisk', formValues.riskLevels.includes(3) ? 'true' : 'false');
            formData.set('projectLowRisk', formValues.riskLevels.includes(2) ? 'true' : 'false');
            formData.set('projectInformationRisk', formValues.riskLevels.includes(1) ? 'true' : 'false');
            formData.set('projectName', formValues.projectName);
            formData.set('projectStartTime', formValues.projectStartTime);
            formData.set('projectEndTime', formValues.projectEndTime);
            formData.set('selectedDuration', formValues.selectedDuration);
            formData.set('user_type', localStorage.getItem('login_user_type'));
            formData.set('local_net_id', localStorage.getItem('login_user_net_id'));
            formData.set('local_unit_id', localStorage.getItem('login_user_unit_id'));
            if (userType === 'S') {
                formData.set('projectnet', report.selectNet);
                formData.set('projectunit', report.selectUnit);
            } else if (userType === 'M') {
                formData.set('projectnet', localStorage.getItem('login_user_net_id'));
                formData.set('projectunit', report.selectUnit);
            } else if (userType === 'N') {
                formData.set('projectnet', localStorage.getItem('login_user_net_id'));
                formData.set('projectunit', localStorage.getItem('login_user_unit_id'));
            }
            formData.set('projecturl', report.selectUrl);
            formData.set('projecturlname', report.local_Url_name);
            formData.set('projectllimit', report.selectedDuration);
            formData.set('projectreport', report.selectReport);
            formData.set('projectreportname', report.local_report_name);
            formData.set('build_date', formValues.build_date);
            formData.set('projectstore', true)
            if (userType === 'S') {
                formData.set('IsadminbuildTrack', 'true');
            } else if (userType === 'M') {
                formData.set('IsNetbuildTrack', 'true');
            } else if (userType === 'N') {
                formData.set('IsUnitbuildTrack', 'true');
            }
            if (userType === 'S') {
                formData.set('IsadminTrack', 'true');
                formData.set('IsNetTrack', 'false');
                formData.set('IsUnitTrack', 'false');
            } else if (userType === 'M') {
                formData.set('IsNetTrack', 'true');
                formData.set('IsadminTrack', 'false');
                formData.set('IsUnitTrack', 'false');
            } else if (userType === 'N') {
                formData.set('IsUnitTrack', 'true');
                formData.set('IsNetTrack', 'false');
                formData.set('IsadminTrack', 'false');
            } else {
                formData.set('IsadminTrack', 'false');
                formData.set('IsNetTrack', 'false');
                formData.set('IsUnitTrack', 'false');
            }
            for (const key in report) {
                formData.append(key, report[key]);
            }
            MySwal.fire({
                title: '處理中...',
                text: '報告修改中',
                allowOutsideClick: false,
                showConfirmButton: false,
                onBeforeOpen: () => {
                    MySwal.showLoading();
                }
            });
            try {
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: { "Authorization": localStorage.getItem('accessToken') },
                    body: formData
                });
                const data = await response.json();
            } catch (error) {
                allReportsSubmittedSuccessfully = false;
                console.error('提交錯誤:', error);
            }
        }
        MySwal.close();

        if (allReportsSubmittedSuccessfully) {
            Swal.fire({
                title: '成功!',
                text: '所有追蹤報告儲存成功，您可以去追蹤清單查看',
                icon: 'success',
                confirmButtonText: '好的'
            }).then((result) => {
                if (result.isConfirmed) {
                    loadData();
                    setExpandedReports({});
                }
            });

            setFormValues({
                projectName: '',
                projectStartTime: '',
                projectEndTime: '',
                riskLevels: [5, 4, 3],
                selectedDuration: '1',
                isSubmitted: false,
            });
            setTrackingReports([
                { selectNet: '', selectUnit: '', selectUrl: '', selectReport: '', local_net_name: '', local_unit_name: '', local_Url_name: '', local_report_name: '', selectedDuration: '1' }
            ]);
        }
    };


    //風險轉換方法
    function getRiskLevelsFromData(reportData) {
        let riskLevels = [];
        if (reportData.projectHeavyRisk) riskLevels.push(5);
        if (reportData.projectHighRisk) riskLevels.push(4);
        if (reportData.projectMediumRisk) riskLevels.push(3);
        if (reportData.projectLowRisk) riskLevels.push(2);
        if (reportData.projectInformationRisk) riskLevels.push(1);
        return riskLevels;
    }


    //寄信
    const handlesendreport = async (reportKey) => {
        const reportData = groupedData[reportKey];
        let apiUrl = api_url + '/api/TrackBackground/TenTrackBackgroundSendEmail';
        const formData = new FormData();
        reportData.forEach((report, index) => {
            for (const key in report) {
                formData.append(`trbgs[${index}].${key}`, report[key]);
            }
        });
        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });

            if (response.ok) {
                const data = await response.json();
                if (data.result.statusCode === 200) {

                    Swal.fire('成功!', data.result.row, 'success');
                    setButtonStates(prevStates => ({
                        ...prevStates,
                        [reportKey]: { isDisabled: true, timer: 60 }
                    }));



                    const timer = setInterval(() => {
                        setButtonStates(prevStates => {
                            const currentTimer = prevStates[reportKey].timer;
                            if (currentTimer === 1) {
                                clearInterval(timer);
                                return { ...prevStates, [reportKey]: { isDisabled: false, timer: 60 } };
                            }
                            return { ...prevStates, [reportKey]: { ...prevStates[reportKey], timer: currentTimer - 1 } };
                        });
                    }, 1000);
                } else {
                    Swal.fire('失敗!', '寄送失敗', 'error');
                }
            } else {
                throw new Error("寄信失敗");
            }
        } catch (error) {
            console.error("寄信錯誤:", error);
        }
    }

    //下載EXCEL
    const handledownloadExcel = async (reportKey) => {
        const reportData = groupedData[reportKey];
        let apiUrl = api_url + '/api/TrackBackground/DownloadTrackBackgroundReportExcel';
        const formData = new FormData();
        formData.append("usertype", userType);
        formData.append("projectName", reportData[0].projectName);
        formData.append("projectEndTime", reportData[0].projectEndTime);
        formData.append("projectStartTime", reportData[0].projectStartTime);
        formData.append("build_date", reportData[0].build_date);
        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });

            if (response.ok && response.status === 200) {
                const blob = await response.blob();
                const downloadUrl = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.style.display = "none";
                a.href = downloadUrl;
                a.download = `${reportData[0].projectName}.xlsx`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(downloadUrl);
                a.remove();
            } else {
                console.error("無法下載檔案，伺服器回應狀態碼:", response.status);
            }
        } catch (error) {
            console.error("下載檔案出錯:", error);
        }
    }


    // 切換模態對話框的顯示狀態
    const toggleModal = () => {
        setModal(!modal);
    };
    const handlestatisticsinformation = (reportKey) => {
        const reportData = groupedData[reportKey];

        let apiUrl = api_url + '/api/TrackBackground/GetOneStatisticsDetail';
        const formData = new FormData();
        formData.append("usertype", userType);
        formData.append("projectName", reportData[0].projectName);
        formData.append("projectEndTime", reportData[0].projectEndTime);
        formData.append("projectStartTime", reportData[0].projectStartTime);
        formData.append("build_id", reportData[0].build_id);
        formData.append("build_date", reportData[0].build_date);

        fetch(apiUrl, {
            method: "POST",
            headers: { "Authorization": localStorage.getItem('accessToken') },
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if (data.statusCode === 200) {
                    setStatistics(data.row[0]);
                } else {
                    throw new Error('Invalid response format');
                }

            })
            .catch(error => {
            });
        toggleModal();
    }
    if (isLoading) {
        return <div>正在加載...</div>;
    }

    if (error) {
        return <div>發生錯誤: {error.message}</div>;
    }

    const userType = localStorage.getItem('login_user_type');
    const net_name = localStorage.getItem('login_user_net_name');
    const unit_name = localStorage.getItem('login_local_unit_name');

    const renderTrackingReportForms = () => {
        return trackingReports.map((report, index) => (
            <Card key={index}>
                <CardHeader className="d-flex justify-content-between align-items-center">
                    追蹤報告 #{index + 1}
                    <Button color="danger" onClick={() => report.id ? deleteReport(report.id) : removeTrackingReport(index)}>
                        {report.id ? <FaTrashAlt /> : <FaTrash />}
                    </Button>
                </CardHeader>
                <CardBody>
                    {renderFormDataUsertype(report, index)}
                </CardBody>
            </Card>
        ));
    };

    const renderFormDataUsertype = (report, index) => {
        if (userType === 'S') {
            return (
                <>
                    <FormGroup row>
                        <Label for={`local_net_id_${index}`} sm={2}>區網名稱</Label>
                        <Col sm={10}>
                            <SelectTenableNet
                                parentName={'superS'}
                                id={`excel_net_name_${index}`}
                                name={`excel_net_name_${index}`}
                                requiredAPI={'/api/JRCC/GetLocalNetId'}
                                handleNetSelectChange={(data) => handleNetSelectChange(data, index)}
                                selectedNet={report.selectNet}  // 傳入已選擇的區網 ID
                                local_net_name={report.local_net_name}  // 傳入區網名稱
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label for={`excel_unit_proxy_name_${index}`} sm={2}>單位名稱</Label>
                        <Col sm={10}>
                            <SelectTenableUnit
                                parentName={'superS'}
                                id={`excel_unit_proxy_name_${index}`}
                                name={`excel_unit_proxy_name_${index}`}
                                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                handleUnitSelectChange={(data) => handleUnitSelectChange(data, index)}
                                selectnet={report.selectNet}  // 傳入選擇的區網
                                local_net_name={report.local_net_name}  // 傳入區網名稱
                                selectedunit={report.selectUnit}  // 傳入已選擇的單位 ID
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for={`TKBG_url_${index}`} sm={2}>主機名稱</Label>
                        <Col sm={10}>
                            <SelectTenableUrl
                                parentName={'superS'}
                                id={`TKBG_url_${index}`}
                                name={`TKBG_url_${index}`}
                                requiredAPI={'/api/JRCC/GetTenableHostip'}
                                onChange={(data) => handleUrlSelectChange(data, index)}
                                selectnet={report.selectNet}  // 傳入選擇的區網
                                local_net_name={report.local_net_name}  // 傳入區網名稱
                                selectedUnit={report.selectUnit}  // 傳入選擇的單位 ID
                                local_unit_name={report.local_unit_name}  // 傳入單位名稱
                                selectedUrl={report.selectUrl}  // 傳入已選擇的主機名稱或 URL
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label sm={2}>選擇時間範圍:</Label>
                        <Col sm={10}>
                            <Input
                                type="select"
                                name={`selectedDuration_${index}`}
                                value={report.selectedDuration}
                                onChange={(e) => updateTrackingReport(index, 'selectedDuration', e.target.value)}
                            >
                                {durationOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label for={`excel_report_list_${index}`} sm={2}>報告名稱</Label>
                        <Col sm={10}>
                            <SelectTenableReport
                                parentName={'superS'}
                                id={`excel_report_list_${index}`}
                                name={`excel_report_list_${index}`}
                                requiredAPI={'/api/TrackBackground/GetTenableReportlist'}
                                selectReport={(data) => selectReport(data, index)}
                                selectnet={report.selectNet}  // 傳入選擇的區網
                                local_net_name={report.local_net_name}  // 傳入區網名稱
                                selectunit={report.selectUnit}  // 傳入選擇的單位 ID
                                local_unit_name={report.local_unit_name}  // 傳入單位名稱
                                selectUrl={report.selectUrl}  // 傳入選擇的 URL
                                selecthost_ip={report.selectedHostIp}  // 傳入選擇的主機 IP
                                selectedDuration={report.selectedDuration}  // 傳入選擇的時間範圍
                                selectedReport={report.selectReport}  // 傳入選擇的報告
                            />
                        </Col>
                    </FormGroup>
                </>

            );
        } else if (userType === 'M') {
            return (
                <>
                    <FormGroup row inline>
                        <Label sm={2}>區網名稱</Label>
                        <Col sm={10}>
                            <span className="form-control-plaintext">{net_name}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for={`excel_unit_proxy_name_${index}`} sm={2}>單位名稱</Label>
                        <Col sm={10}>
                            <SelectTenableUnit
                                parentName={'superM'}
                                id={`excel_unit_proxy_name_${index}`}
                                name={`excel_unit_proxy_name_${index}`}
                                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                handleUnitSelectChange={(data) => handleUnitSelectChange(data, index)}
                                selectnet={localStorage.getItem('login_user_net_id')}
                                local_net_name={net_name}
                                selectedunit={report.selectUnit}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for={`TKBG_url_${index}`} sm={2}>主機名稱</Label>
                        <Col sm={10}>
                            <SelectTenableUrl
                                parentName={'superM'}
                                id={`TKBG_url_${index}`}
                                name={`TKBG_url_${index}`}
                                requiredAPI={'/api/JRCC/GetTenableHostip'}
                                onChange={(data) => handleUrlSelectChange(data, index)}
                                selectnet={localStorage.getItem('login_user_net_id')}
                                local_net_name={net_name}
                                selectedUnit={report.selectUnit}
                                local_unit_name={report.local_unit_name}
                                selectedUrl={report.selectUrl}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label sm={2}>選擇時間範圍:</Label>
                        <Col sm={10}>
                            <Input
                                type="select"
                                name={`selectedDuration_${index}`}
                                value={report.selectedDuration}  // 自動帶入選擇的時間範圍
                                onChange={(e) => updateTrackingReport(index, 'selectedDuration', e.target.value)}
                            >
                                {durationOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for={`excel_report_list_${index}`} sm={2}>報告名稱</Label>
                        <Col sm={10}>
                            <SelectTenableReport
                                parentName={'superM'}
                                id={`excel_report_list_${index}`}
                                name={`excel_report_list_${index}`}
                                requiredAPI={'/api/TrackBackground/GetTenableReportlist'}
                                selectReport={(data) => selectReport(data, index)}
                                selectnet={localStorage.getItem('login_user_net_id')}
                                local_net_name={net_name}
                                selectunit={report.selectUnit}
                                local_unit_name={report.local_unit_name}
                                selectUrl={report.selectUrl}
                                selecthost_ip={report.selectedHostIp}
                                selectedDuration={report.selectedDuration}
                                selectedReport={report.selectReport}
                            />
                        </Col>
                    </FormGroup>

                </>
            );
        } else if (userType === 'N') {
            return (
                <>
                    <FormGroup row inline>
                        <Label sm={2}>區網名稱</Label>
                        <Col sm={10}>
                            <span className="form-control-plaintext">{net_name}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label sm={2}>區網名稱</Label>
                        <Col sm={10}>
                            <span className="form-control-plaintext">{unit_name}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for={`TKBG_url_${index}`} sm={2}>主機名稱</Label>
                        <Col sm={10}>
                            <SelectTenableUrl
                                parentName={'superN'}
                                id={`TKBG_url_${index}`}
                                name={`TKBG_url_${index}`}
                                requiredAPI={'/api/JRCC/GetTenableHostip'}
                                onChange={(data) => handleUrlSelectChange(data, index)}
                                selectedUnit={localStorage.getItem('login_user_unit_id')}
                                local_unit_name={unit_name}
                                selectnet={localStorage.getItem('login_user_net_id')}
                                local_net_name={net_name}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2}>選擇時間範圍:</Label>
                        <Col sm={10}>
                            <Input
                                type="select"
                                name={`selectedDuration_${index}`}
                                value={report.selectedDuration}
                                onChange={(e) => updateTrackingReport(index, 'selectedDuration', e.target.value)}
                            >
                                {durationOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for={`excel_report_list_${index}`} sm={2}>報告名稱</Label>
                        <Col sm={10}>
                            <SelectTenableReport
                                parentName={'superN'}
                                id={`excel_report_list_${index}`}
                                name={`excel_report_list_${index}`}
                                requiredAPI={'/api/TrackBackground/GetTenableReportlist'}
                                selectReport={(data) => selectReport(data, index)}
                                selectedUnit={localStorage.getItem('login_user_unit_id')}
                                local_unit_name={unit_name}
                                selectnet={localStorage.getItem('login_user_net_id')}
                                local_net_name={net_name}
                                selectUrl={report.selectUrl}
                                selecthost_ip={report.selectedHostIp}
                                selectedDuration={report.selectedDuration}
                                selectedReport={report.selectedReport}
                            />
                        </Col>
                    </FormGroup>
                </>
            );
        }


    }

    return (
        <div className="tracking-list">

            {currentItems.map(([groupKey, reports], index) => {
                const report = reports[0];

                return (
                    <div key={report.id} className="tracking-group">
                        <div className="tracking-item wrap-text">
                            <h4>{report.projectName}</h4>
                            <div className="tracking-time-actions">
                                <div className="tracking-time-row">
                                    <p className="tracking-time">追蹤時間: {report.projectStartTime} ~ {report.projectEndTime}</p>
                                </div>
                            </div>
                            <div className="tracking-time-actions">
                                <div className="tracking-time-row">
                                    <p className="tracking-time">建立追蹤人員: {report.build_id}</p>    </div>

                                <div className="action-buttons">
                                    <Button
                                        className="btn btn-success"
                                        onClick={() => toggleExpand(groupKey)}
                                        disabled={report.isNetbuildTrack && userType === 'S'}
                                    >
                                        追蹤內容
                                    </Button>
                                    <Button
                                        className="btn btn-info"
                                        onClick={() => handleItemClick(report.build_date, report.projectName, report.projectStartTime, report.projectEndTime)}
                                    >
                                        詳細資訊
                                    </Button>
                                    <Button
                                        className="btn btn-info"
                                        onClick={() => handlestatisticsinformation(groupKey)}
                                    >
                                        統計資訊
                                    </Button>
                                    <Button
                                        className={`btn ${buttonStates[groupKey]?.isDisabled ? 'btn-secondary' : 'btn-danger'}`}
                                        onClick={() => {
                                            handlesendreport(groupKey);
                                        }}
                                        disabled={buttonStates[groupKey]?.isDisabled || !report.projectStore}
                                    >
                                        {buttonStates[groupKey]?.isDisabled ? `${buttonStates[groupKey]?.timer}秒` : '寄信'}
                                    </Button>

                                    {userType !== 'N' && (
                                        <Button
                                            className="btn btn-danger"
                                            onClick={() => handledownloadExcel(groupKey)}
                                        >
                                            下載EXCEL
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </div>
                        {
                            expandedReports[groupKey] && (
                                <div className="tracking-details">
                                    <Form onSubmit={handleSubmit}>
                                        <FormGroup row>
                                            <Label for="projectName" sm={2}>追蹤計畫名稱:</Label>
                                            <Col sm={10}>
                                                <Input
                                                    type="text"
                                                    name="projectName"
                                                    id="projectName"
                                                    value={formValues.projectName}
                                                    onChange={handleInputChange}
                                                    readOnly={formValues.projectStore}
                                                />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label for="projectStartTime" sm={2}>追蹤計畫開始時間:</Label>
                                            <Col sm={10}>
                                                <Input
                                                    type="date"
                                                    name="projectStartTime"
                                                    id="projectStartTime"
                                                    value={formValues.projectStartTime}
                                                    onChange={handleInputChange}
                                                    readOnly={formValues.projectStore}
                                                />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label for="projectEndTime" sm={2}>追蹤計畫結束時間:</Label>
                                            <Col sm={10}>
                                                <Input
                                                    type="date"
                                                    name="projectEndTime"
                                                    id="projectEndTime"
                                                    value={formValues.projectEndTime}
                                                    onChange={handleInputChange}
                                                />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label sm={2}>風險層級:</Label>
                                            <Col sm={10}>
                                                <div className="d-flex flex-row">
                                                    {Object.entries(riskLevelMapping).map(([key, numValue]) => (
                                                        <FormGroup check inline key={key}>
                                                            <Label check>
                                                                <Input
                                                                    type="checkbox"
                                                                    name="riskLevels"
                                                                    value={key}
                                                                    checked={formValues.riskLevels.includes(numValue)}
                                                                    onChange={handleRiskLevelChange}
                                                                    disabled={formValues.projectStore}
                                                                />
                                                                {key}
                                                            </Label>
                                                        </FormGroup>
                                                    ))}
                                                </div>
                                            </Col>
                                        </FormGroup>
                                        {renderTrackingReportForms()}
                                        <Button onClick={addTrackingReport} color="success">新增追蹤報告</Button>
                                        {' '}
                                        <Button onClick={handleSave} color="secondary" disabled={formValues.projectStore || formValues.projectTemporarilySave === false}>儲存</Button>
                                        {' '}
                                        <Button type="submit" color="primary" >
                                            提交
                                        </Button>
                                    </Form>
                                </div>
                            )
                        }

                    </div>
                );
            })}
            <div className="pagination-controls">
                <label>
                    Rows per page:
                    <select value={itemsPerPage} onChange={handleItemsPerPageChange} className="custom-select custom-select-sm">
                        {[10, 20, 30, 50].map(number => (
                            <option key={number} value={number}>{number}</option>
                        ))}
                    </select>
                </label>
                <span>
                    {`${indexOfFirstItem}-${indexOfLastItem} of ${Object.entries(groupedData).length}`}
                </span>
                <ul className='pagination'>
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <a onClick={() => setCurrentPage(1)} className="page-link">««</a>
                    </li>
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <a onClick={() => setCurrentPage(currentPage - 1)} className="page-link">«</a>
                    </li>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(number => (
                        <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
                            <a onClick={() => setCurrentPage(number)} className="page-link">
                                {number}
                            </a>
                        </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <a onClick={() => setCurrentPage(currentPage + 1)} className="page-link">»</a>
                    </li>
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <a onClick={() => setCurrentPage(totalPages)} className="page-link">»»</a>
                    </li>
                </ul>
            </div>


            <Modal isOpen={modal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>統計資訊</ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label for="unrespondedUnitCount">未回覆單位數量</Label>: {statistics.totalUnrespondedUnitCount}
                        </FormGroup>
                        <FormGroup>
                            <Label for="notPassedUnitCount">未通過單位數量</Label>: {statistics.totalNotPassedUnitCount}
                        </FormGroup>
                        <FormGroup>
                            <Label for="passedUnitCount">通過的單位數量</Label>: {statistics.totalPassedUnitCount}
                        </FormGroup>
                        <FormGroup>
                            <Label for="totalUnitCount">全部單位數量</Label>: {statistics.grandTotalUnitCount}
                        </FormGroup>
                        <FormGroup>
                            <Label for="unrespondedUnitCountForNonSubmission">未回覆單位數量 (未提交回復的單位)</Label>: {statistics.totalUnrespondedUnitCountForNonSubmission}
                        </FormGroup>
                        <FormGroup>
                            <Label for="notPassedUnitCountForReviewed">未通過單位數量 (已經審核但回復為修正需再填寫回復的單位)</Label>: {statistics.totalNotPassedUnitCountForReviewedAndNeedsRevision}
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleModal}>取消</Button>
                </ModalFooter>
            </Modal>

        </div >
    );
}

export default ViewTenableTrackingList;
